<template>
  <div>
    <b-table
      responsive
      striped
      class="text-center table-list mb-0"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template v-slot:cell(id)="data">
        <router-link :id="'inventoryBookDetail'+data.item.campaignId"
          :to="`/inventory/create-campaign/${data.item.campaignId}?brandID=1  `"
          >ดูรายละเอียด</router-link
        >
      </template>

      <template v-slot:cell(campaignPeriod)="data">
        <p class="mb-0">
          {{ new Date(data.item.campaignStartTime) | moment($formatDateTime) }}
          <br />
          - {{ new Date(data.item.campaignEndTime) | moment($formatDateTime) }}
        </p>
      </template>

      <template v-slot:cell(campaignBooking)="data">
        <p class="mb-0">
          {{ new Date(data.item.reserveStartTime) | moment($formatDateTime) }}
          <br />
          - {{ new Date(data.item.reserveEndTime) | moment($formatDateTime) }}
        </p>
      </template>

      <template v-slot:cell(salesChannel)="data">
        <div v-if="data.item.salesChannel">
          <p class="md-0">{{ data.item.salesChannel }}</p>
        </div>
        <div v-else>-</div>
      </template>

      <template #cell(totalSku)="data">
        <div>{{ data.item.totalSku | numeral("0,0") }}</div>
      </template>

      <template #cell(totalReserve)="data">
        <div>{{ data.item.totalReserve | numeral("0,0") }}</div>
      </template>

      <template #cell(remainInStock)="data">
        <div>{{ data.item.remainInStock | numeral("0,0") }}</div>
      </template>
    </b-table>
    <b-row class="no-gutters px-3 px-sm-0 bg-white" v-if="!isBusy">
      <b-col class="form-inline justify-content-center justify-content-sm-end">
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="filterInventoryList.page"
            :total-rows="rows"
            :per-page="filterInventoryList.pageSize"
            class="m-md-0 page-item"
            @change="pagination"
          ></b-pagination>
        </div>
        <b-form-select
          class="mr-sm-3 select-page"
          v-model="filterInventoryList.pageSize"
          @change="hanndleChangePerpage"
          :options="pageOptions"
        ></b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "InventoryBookProduct",
  data: function() {
    return {
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      rows: 0,
      filterInventoryList: {
        search: "",
        CampaignStatus: [],
        SalesChannel: [],
        StartDate: "",
        EndDate: "",
        ReserveStartDate: "",
        ReserveEndDate: "",
        page: 1,
        pageSize: 10,
      },
      isBusy: false,
      items: [],
      fields: [
        {
          key: "campaignName",
          label: "ชื่อแคมเปญ",
          class: "w-200",
        },
        {
          key: "campaignPeriod",
          label: "ช่วงเวลาแคมเปญ",
          class: "w-200",
        },
        {
          key: "campaignBooking",
          label: "ช่วงเวลาจอง",
          class: "w-200",
        },
        {
          key: "salesChannel",
          label: "ช่องทางจำหน่าย",
          class: "w-100px",
        },
        {
          key: "totalSku",
          label: "จำนวน SKU",
          class: "w-100px",
        },
        {
          key: "totalReserve",
          label: "จำนวนชิ้นที่จอง",
          class: "w-100px",
        },
        {
          key: "remainInStock",
          label: "จำนวนคงเหลือในคลัง",
          class: "w-100px",
        },
        {
          key: "status",
          label: "สถานะ",
          class: "w-100px",
        },
        {
          key: "id",
          label: "",
          class: "w-100px",
        },
      ],
    };
  },
  async created() {
    await this.getFilter();
    this.getProductList();
  },
  methods: {
    getFilter(){
      if(this.$route.query.search){
        this.filterInventoryList.search = this.$route.query.search;
      }
      if(this.$route.query.CampaignStatus){
        this.filterInventoryList.CampaignStatus = this.$route.query.CampaignStatus.split(",").map(Number);
      }
      if(this.$route.query.SalesChannel){
        this.filterInventoryList.SalesChannel = this.$route.query.SalesChannel.split(",").map(Number);
      }
      if(this.$route.query.StartDate){
        this.filterInventoryList.StartDate = this.$route.query.StartDate;
      }
      if(this.$route.query.EndDate){
        this.filterInventoryList.EndDate = this.$route.query.EndDate;
      }
      if(this.$route.query.ReserveStartDate){
        this.filterInventoryList.ReserveStartDate = this.$route.query.ReserveStartDate;
      }
      if(this.$route.query.ReserveEndDate){
        this.filterInventoryList.ReserveEndDate = this.$route.query.ReserveEndDate;
      }
      if(this.$route.query.page){
        this.filterInventoryList.page = parseInt(this.$route.query.page) || 1;
      }
      if(this.$route.query.pageSize){
        this.filterInventoryList.pageSize = parseInt(this.$route.query.pageSize) || 10;
      }
    },
    setFilter() {
      this.$router.push({ path: '/inventory', 
        query: { 
          brandID: this.$route.query.brandID,
          search: this.filterInventoryList.search,
          CampaignStatus: this.filterInventoryList.CampaignStatus.toString(),
          SalesChannel: this.filterInventoryList.SalesChannel.toString(),
          StartDate : this.filterInventoryList.StartDate || "",
          EndDate : this.filterInventoryList.EndDate || "",
          ReserveStartDate: this.filterInventoryList.ReserveStartDate,
          ReserveEndDate: this.filterInventoryList.ReserveEndDate,
          pageSize : this.filterInventoryList.pageSize ,
          page: this.filterInventoryList.page,
          tab: this.$route.query.tab || 1
        }
      }).catch(err => {});
    },
    pagination(Page) {
      this.filterInventoryList.page = Page;
      this.setFilter();
      this.getProductList();
    },
    isActive: function(menuItem) {
      return this.activeItem == menuItem;
    },
    getProductList(filter) {
      if (filter) {
        this.filterInventoryList = filter;
      }
      this.isBusy = true;
      this.axios
        .post(
          `${this.$baseUrl}/stockdistribute/campaign/list`,
          this.filterInventoryList
        )
        .then((data) => {
          this.rows = data.totalCount;
          this.items = data.data;
        });
        this.isBusy = false;
    },
    hanndleChangePerpage(value) {
      this.filterInventoryList.page = 1;
      this.filterInventoryList.pageSize = value;
      this.setFilter();
      this.getProductList();
    },
  },
};
</script>

<style></style>
